import React, {useState, useEffect} from 'react';
import CallCenterStructure from '../CallCenterStructure/CallCenterStructure';
import {Times, ViewPen} from '../../assets/icons';
import MenuDeleteModal from '../../component/MenuDeleteModal/MenuDeleteModal';
import styles from '../../styles/CompanyTransactionChannelMaster.module.scss';
import {useQuery, useMutation, useQueryClient} from 'react-query';
import axiosProperty from '../../service/HttpConfig';
import ApiConfig from '../../service/ApiConfig';
import Paginate from '../../component/Paginate/Paginate';
import { Headers } from '../../service/Essentials';
import swal from 'sweetalert';
import { ProgramID } from '../../service/Essentials';
import ErrorMessage from '../../component/ErrorMessage/ErrorMessage';
import ClearInputModal from '../../component/ClearInputModal/ClearInputModal';

const CompanyTransactionChannelMaster = () => {
  const [clearModal, setClearModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [channelCode, setChannelCode] = useState('');
  const [channelName, setChannelName] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [isSubmit, setIsSubmit] = useState(true);
  const [updateID, setUpdateID] = useState('');
  const [selectedItemID, setSelectedItemId] = useState('');
  const queryClient = useQueryClient();
  const [error, setError] = useState('oops... something went wrong');
  const [errors, setErrors] = useState(null);

  const onClose = () => {
    setDeleteModal(false);
  };

  const formData = {
    transaction_code: channelCode,
    transaction_name: channelName,
    program_id: ProgramID(),
  };

  //RedirectToLogin();

  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  const fetchTransactionChannels = async page => {
    const res = await axiosProperty.get(
      ApiConfig.fetchTransactionChannel + `?page=${page}`,
      {
        headers: Headers(),
      },
    );
    return res.data;
  };
  const {data, status} = useQuery(
    ['transactionchannels', page],
    () => fetchTransactionChannels(page),
    {keepPreviousData: true},
  );

  useEffect(() => {
    setFilteredData(data?.data || []);
  }, [data]);

  const handleSearchInputChange = searchTerm => {
    setSearchTerm(searchTerm);
    if (searchTerm === '') {
      setFilteredData(data?.data || []); // Reset to original data if search term is empty
    } else if (data?.data) {
      const filtered = data.data.filter(
        (item) =>
          item.channel_name.toLowerCase().includes(searchTerm.toLowerCase())||
          item.channel_code.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const addTransactionChannel = async () => {
    try{
        await axiosProperty.post(ApiConfig.createTransactionChannel, formData, 
        {
          headers:Headers(),
      }
        );
  setErrors(null);
  setChannelCode('');
  setChannelName('');
  swal({
    title: "Success!",
    text: "Transaction Channel created successfully",
    icon: "success",
  });

    }catch(err){
      if(err.response){
       setError(err.response.data.message);
       setErrors(err.response.data);
      }else{
      setError('Something went wrong, try again'); 
      }
      console.log(err);
      swal({
        title: 'Error!',
        text: error || 'server issue',
        icon: 'error',
      });
    }
  };

  const {mutate: addTransactionChannelMutation} = useMutation({
    mutationFn: addTransactionChannel,
    onSuccess: () => {
      queryClient.invalidateQueries(['transactionchannels']);
    },
  });

  const updateTransactionChannel = async () => {
    try {
      await axiosProperty.patch(
        ApiConfig.updateTransactionChannel + `/${updateID}`,
        formData,
        {
          headers:Headers(),
      }
        );
        setErrors(null);
        setChannelCode('');
        setChannelName('');
        setIsSubmit(true);
        setIsUpdate(false);

      swal({
        title: 'Success!',
        text: 'Transaction Channel updated successfully',
        icon: 'success',
      });
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
        setErrors(err.response.data);
      }else{
       setError('Something went wrong, try again'); 
      }
      console.log(err);

      swal({
        title: 'Error!',
        text: error,
        icon: 'error',
      });
    }
  };

  const {mutate: updateTransactionChannelMutation} = useMutation({
    mutationFn: updateTransactionChannel,
    onSuccess: () => {
      queryClient.invalidateQueries(['transactionchannels']);
    },
  });

  const editTrandsactionChannel = async id => {
    try {
      const res = await axiosProperty.get(
        ApiConfig.editTransactionChannel + `/${id}`,
        {
          headers: Headers(),
        },
      );
      setIsUpdate(true);
      setIsSubmit(false);
      setChannelCode(res.data.data.transaction_code);
      setChannelName(res.data.data.transaction_name);
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
      } else {
        setError('Something went wrong, try again');
      }
    //  console.log(err);
      swal({
        title: 'Warning!',
        text: error,
        icon: 'warning',
      });
    }
  };

  const deleteTransactionChannel = async id => {
    try {
      const res = await axiosProperty.delete(
        ApiConfig.deleteTransactionChannel + `/${id}`,
        {
          headers: Headers(),
        },
      );
      setDeleteModal(false);
      swal({
        title: 'Success!',
        text: 'Transaction Channel deleted successfully',
        icon: 'success',
      });
      queryClient.invalidateQueries(['transactionchannels']);
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
      } else {
        setError('Something went wrong, try again');
      }
      console.log(err);

      swal({
        title: 'Error!',
        text: error,
        icon: 'error',
      });
    }
  };
  return (
    <CallCenterStructure>
      <div className={styles.companyTransactionTypeMasterSetup}>
        <div className={styles.headerText}>
          <p>Company Transaction Channel Master</p>
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.fieldContainer1}>
            <div className={styles.innerFieldContainer1}>
              <label htmlFor="">
                Enter Transaction Channel Code<sup>*</sup>
              </label>
              <input
                value={channelCode}
                type="text"
                onChange={e => setChannelCode(e.target.value)}
              />
            </div>
            <div className={styles.innerFieldContainer1}>
              <label htmlFor="">
                Enter Transaction Channel Name<sup>*</sup>
              </label>
              <input
                value={channelName}
                type="text"
                onChange={e => setChannelName(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.buttonContainer}>
            {isSubmit && (
              <button
                className={styles.submit}
                onClick={() => addTransactionChannelMutation()}>
                Submit
              </button>
            )}
            {isUpdate && (
              <button
                className={styles.submit}
                onClick={() => updateTransactionChannelMutation()}>
                Update
              </button>
            )}
            <button
              className={styles.reset}
              type="button"
              onClick={() => setClearModal(true)}>
              Reset
            </button>
          </div>
          <ErrorMessage errMsg={errors} />
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.tableContainer}>
            <table className={styles.mainTable}>
              <thead>
                <tr>
                  <th>Transaction Channel Code</th>
                  <th>Transaction Channel Name</th>

                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map(each => (
                    <tr key={each.code}>
                      <td>{each.transaction_code}</td>
                      <td>{each.transaction_name}</td>

                      <td>
                        <div className={styles.iconContainer}>
                          <span
                            className={styles.icon}
                            onClick={() => {
                              editTrandsactionChannel(each.id);
                              setUpdateID(each.id);
                            }}>
                            <ViewPen />
                          </span>
                          <span
                            className={styles.icon}
                            onClick={() => {
                              setDeleteModal(true);
                              setSelectedItemId(each.id);
                            }}>
                            <Times />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colspan="3">No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className={styles.paginationContainer}>
            <Paginate page={page} data={data} setPage={setPage} />
          </div>
        </div>
        {/* Pass your clear input function to clearInputFn */}
        <ClearInputModal
          //   clearInputFn={handleReset}
          clearModalStatus={clearModal}
          clearInputModalState={setClearModal}
        />
        {deleteModal && (
          <MenuDeleteModal
            onClose={onClose}
            onDelete={() => deleteTransactionChannel(selectedItemID)}
          />
        )}
      </div>
    </CallCenterStructure>
  );
};

export default CompanyTransactionChannelMaster;
